<template>
  <div class="package-page">
    <div class="modal-header">
      <span>{{ $t('all_package') }}</span>
      <button class="close-btn" @click="close">✕</button>
    </div>

    <div class="modal-body">
      <div class="package-card" :class="{active: type==='daily'}" @click="go_sub('daily')">
        <div class="info-2">
          <div class="name">{{ $t('daily_package') }}</div>
          <ul>
            <li>{{ $t('chances_2_day') }}</li>
            <li style="color: #f8b4d9;">{{ $t('free_first_sub') }}</li>
          </ul>
        </div>
        <div class="price">0.1 USD</div>
      </div>

      <div class="package-card" :class="{active: type==='weekly'}" @click="go_sub('weekly')">
        <div class="info-2">
          <div class="name">{{ $t('weekly_package') }}<span class="best">{{ $t('best_choice') }}</span></div>
          <ul>
            <li>{{ $t('chances_14_day') }}</li>
          </ul>
        </div>
        <div class="price">0.6 USD</div>
      </div>

      <div class="package-card" :class="{active: type==='monthly'}" @click="go_sub('monthly')">
        <div class="info-2">
          <div class="name">{{ $t('monthly_package') }}</div>
          <ul>
            <li>{{ $t('chances_60_day') }}</li>
          </ul>
        </div>
        <div class="price">2.0 USD</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mobile: '',
      type: '',
      submitting: false,
      checkUserTimer: null,
      checkUserPollingActive: false,
    }
  },
  created() {
    if (this.$route.query.mobile) {
      this.mobile = this.$route.query.mobile
    }
    if (this.mobile) {
      this.startCheckUserPolling()
    }
  },
  beforeDestroy() {
    this.stopCheckUserPolling()
  },
  methods: {
    stopCheckUserPolling() {
      this.checkUserPollingActive = false
      if (this.checkUserTimer) {
        clearInterval(this.checkUserTimer)
        this.checkUserTimer = null
      }
    },
    startCheckUserPolling() {
      const that = this
      that.stopCheckUserPolling()
      that.checkUserPollingActive = true

      const poll = () => {
        that.$api.post('/api/user/real_check_user', {mobile: that.mobile}, r => {
          if (!that.checkUserPollingActive) {
            return
          }
          if (r.code == 1) {
            that.stopCheckUserPolling()
            that.submitting = false
            that.$parent.loadModal(false)
            localStorage.setItem('token', r.data.userinfo.token)
            localStorage.setItem('mobile', r.data.userinfo.mobile)
            that.$router.push({path: '/'})
          }
        })
      }

      poll()
      that.checkUserTimer = setInterval(poll, 2000)
    },
    go_sub(sub_type) {
      let that = this
      if (that.submitting) {
        return
      }
      that.type = sub_type
      if (!that.mobile) {
        that.$utils.alertText(that.$t('loginTips'), 60)
        that.close()
        return
      }
      let params = new URLSearchParams(this.$route.query);
      // 移除重复项
      params.delete('mobile');
      params.delete('subappid');
      // 添加新参数
      params.set('mobile', that.mobile);
      params.set('subappid', that.type);
      that.submitting = true
      that.$parent.loadModal(true)
      let url = '/api/user/create_requestId?' + params.toString();
      that.$api.get(url, {}, r => {
        that.submitting = false
        that.$parent.loadModal(false);
        if (r.code == 1) {
          window.location.href = r.data.url;
        }else if (r.code == 2){
          that.stopCheckUserPolling()
          localStorage.setItem('token', r.data.userinfo.token)
          localStorage.setItem('mobile', r.data.userinfo.mobile)
          that.$router.push({path: '/'})
        }else{
          that.$utils.alertText(r.msg, 80);
        }
      }, () => {
        that.submitting = false
        that.$parent.loadModal(false);
        that.$utils.alertText('Request failed', 80);
      })
    },
    close() {
      if (this.submitting) {
        return
      }
      this.$parent.loadModal(false)
      this.$router.push({
        path: '/login',
        query: Object.assign({}, this.$route.query, {mobile: this.mobile})
      })
    }
  }
}
</script>

<style scoped>
.package-page {
  position: fixed;
  inset: 0;
  background: url(/static/images/bg2.jpg) no-repeat center bottom #040b35;
  color: #fff;
  z-index: 999;
  display: flex;
  flex-direction: column;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0.5rem;
  font-size: 1.5rem;
  font-weight: 700;
  color: white;
}

.close-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #fff;
  cursor: pointer;
}

.modal-body {
  flex: 1;
  overflow-y: auto;
  padding: 1rem;
}

.package-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.2rem;
  border-radius: 0.5rem;
  margin-bottom: 1rem;
  background: #1a1a1a;
  cursor: pointer;
  transition: 0.2s;
  border: 0.03rem solid #6d6369;
}

.package-card:hover {
  background: #222;
}

.package-card.active {
  border: 0.03rem solid #ff6bcb;
}

.package-card .name {
  font-size: 1rem;
  font-weight: 600;
  color: #f8b4d9;
}

.package-card .best {
  background: #444;
  color: #f99;
  font-size: 0.5rem;
  padding: 0.03rem 0.08rem;
  border-radius: 0.08rem;
  margin-left: 0.11rem;
}

.package-card ul {
  margin: 0.07rem 0 0;
  padding: 0;
  list-style: none;
  font-size: 0.8rem;
  color: #ddd;
}

.package-card .price {
  background: #ffd84d;
  color: #111;
  font-weight: 700;
  padding: 0.08rem 0.5rem;
  border-radius: 0.5rem;
  font-size: 0.8rem;
  min-width: 2rem;
  text-align: center;
  margin-right: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/page/sub.vue